import { useMemo } from 'react';
import { useCurrency } from '../context';

export function useFormatCurrency(price) {
	const [currency] = useCurrency();

	return useMemo(() => {
		const formatter = new Intl.NumberFormat('en-US', {
			style: 'currency',
			currency,
			minimumFractionDigits: 2,
		});

		return formatter.format(price);
	}, [price, currency]);
}
